import Text12 from '@sdk/components/ui/typography/Text12';
import Href from '@sdk/components/ui/Href';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import {
  Container,
  TextContainer,
} from '@web/labor/LaborInformationBox/laborInformationBox.styles';
import { InformationBoxProps } from '@web/labor/LaborInformationBox/laborInformationBox.types';
import { getSectionDescription } from '@web/labor/LaborInformationBox/laborInformationBox.utils';

const LaborInformationBox = ({
  sectionValue,
  sectionPropertyName,
  navigateTo,
  openAddShiftModal,
  hasVisitiedLaborCostSettingsTab,
  employees,
  positions,
}: InformationBoxProps) => {
  const { linkText, descriptionText, action, isVisible } = getSectionDescription({
    sectionValue,
    sectionPropertyName,
    navigateTo,
    openAddShiftModal,
    hasVisitiedLaborCostSettingsTab,
    employees,
    positions,
  });

  if (!isVisible) {
    return null;
  }

  return (
    <Container pLeft={20} pRight={20} pTop={10} pBottom={10}>
      <TextContainer>
        <Href onClick={action} fontSize={12} themeColor={ThemeColorType.primary}>
          {linkText}
        </Href>
        <Text12 themeColor={ThemeColorType.gray}>&nbsp;{descriptionText}</Text12>
      </TextContainer>
    </Container>
  );
};

export default LaborInformationBox;
